/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Surcharge_LabelInputs */

const vi_order_surcharge_label = /** @type {(inputs: Order_Surcharge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phụ thu`)
};

/**

* @param {Order_Surcharge_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_surcharge_label = /** @type {((inputs?: Order_Surcharge_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Surcharge_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_surcharge_label(inputs)
});